<template>
  <div class="dropdown-field -type02" @click="showDetail = !showDetail">
    <div class="section">
      <span>{{drwotAcnInfo.drwotAcno}} ({{drwotAcnInfo.drwotCncycd}})</span>
      <span class="name">{{drwotAcnInfo.drwotAlias}}</span>
      <i class="icon icon-list" v-if="!showDetail" />
      <i class="icon icon-dropdown-arrow" v-if="showDetail" :class="{ rotate180: showDetail }" />
    </div>
    <div class="dropdown-field--list -type02" v-if="showDetail">
      <template v-if="selectRow || step >= 2">
        <div class="list-item">
          <div class="tit">{{ /*송금 통화 종류*/ $t("MFXD-01-01-15-01") }}</div>
          <div class="dec">{{drwotAcnInfo.fxCncycd}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /*송금금액*/ $t("MFXD-01-01-15-02") }}</div>
          <div class="dec">
            <span class="exchange-unit">{{drwotAcnInfo.fxCncycd}}</span>
            <span class="amount" v-html="$num(drwotAcnInfo.outwdRmtancAmt, null, true)"></span>
          </div>
        </div>
      </template>
      <template v-if="selectRow || step >= 3">
        <hr />
        <div class="list-item">
          <div class="tit">{{ /* 수취인 계좌번호 */ $t("MFXD-01-01-15-03") }}</div>
          <div class="dec">{{param.draweAcitmNo}} ({{drwotAcnInfo.fxCncycd}})</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 수취인 성명 */ $t("MFXD-01-01-15-04") }}</div>
          <div class="dec">{{param.draweName}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 수취인 전화번호 */ $t("MFXD-01-01-15-05") }}</div>
          <div class="dec">{{param.indicMatrCtnt6}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{/* 수취인 주소(영문) */ $t("MFXD-01-01-15-06")}}</div>
          <div
            class="dec"
          >{{param.draweAddrCtnt1}} {{param.draweAddrCtnt2}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{/* 수취인 도시 */ $t("MFXD-02-04-01-01")}}</div>
          <div class="dec">{{param.draweAddrCtnt3}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{/* 수취인 국가 */ $t("MFXD-02-04-01-02")}}</div>
          <div class="dec">{{param.draweISONatnlCd}}</div>
        </div>
      </template>
      <template v-if="selectRow || step >= 4">
        <hr />
        <div class="list-item">
          <div class="tit">{{ /* 수취은행 BIC 코드 */ $t("MFXD-01-01-15-07") }}</div>
          <div class="dec">{{param.pybnkBIC}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 수취은행명 */ $t("MFXD-01-01-15-08") }}</div>
          <div class="dec">{{param.pybnkName}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{/* 수취은행주소(영문) */ $t("MFXD-01-01-15-09")}}</div>
          <div
            class="dec"
          >{{param.paymtBnkzAddrCtnt1}} {{param.paymtBnkzAddrCtnt2}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{/* 수취은행 도시 */ $t("MFXD-02-04-01-03")}}</div>
          <div class="dec">{{param.paymtBnkzAddrCtnt3}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{/* 수취은행 국가 */ $t("MFXD-02-04-01-04")}}</div>
          <div class="dec">{{param.pybnkISONatnlCd}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 수취은행번호 */ $t("MFXD-01-01-15-10")}}</div>
          <div class="dec">{{param.indicMatrCtnt1}}</div>
        </div>
      </template>
      <template v-if="selectRow || step >= 5">
        <hr />
        <div
          class="list-item"
          v-if="!(siteCode == $config.SITECODE_OGAUC || siteCode == $config.SITECODE_OGLD)"
        >
          <div class="tit">{{ /* 송금의뢰인 성명 */ $t("MFXD-01-01-16-22") }}</div>
          <div class="dec">{{param.rmtrName}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 송금의뢰인 전화번호 */ $t("MFXD-01-01-16-23") }}</div>
          <div class="dec">{{param.ovsesRmtancApctTelno}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 송금의뢰인 주소 */ $t("MFXD-01-01-16-24")}}</div>
          <div class="dec">{{param.rmtrAddrCtnt1}} {{param.rmtrAddrCtnt2}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 송금의뢰인 도시(영문) */ $t("MFXD-02-04-01-05")}}</div>
          <div class="dec">{{param.rmtrAddrCtnt3}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 송금의뢰인 국가 */ $t("MFXD-02-04-01-06")}}</div>
          <div class="dec">{{param.rmtrISONatnlCd}}</div>
        </div>
        <div class="list-item">
          <div class="tit">{{ /* 적요 */ $t("MFXD-01-01-16-25")}}</div>
          <div
            class="dec"
          >{{param.rmtancRelatdCtnt1}} {{param.rmtancRelatdCtnt2}} {{param.rmtancRelatdCtnt3}} {{param.rmtancRelatdCtnt4}}</div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  computed: {
    ...mapFields("foreignExchange/ovsesRmtancAplcnInfoInptReq", ["drwotAcnInfo", "param"]),
    ...mapFields(["siteCode"]),
  },
  props: {
    selectRow: {
      type: Boolean,
      default: false,
    },
    step: { type: Number, default: 5 },
  },
  mounted() {},
  data() {
    return {
      showDetail: false,
    };
  },
  methods: {},
};
</script>